(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_cde8f9b"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lux-product')) return;

    var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };

    class LuxProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.form = this.querySelector('.lpd__form');
        this.gallery = this.querySelector('.lpd__gallery');
        this.main = this.querySelector('.lpd__main');
        this.thumbs = this.querySelector('.lpd__thumbs');
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('.lpd__tile'));
        this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-option-index]'));
        this.qty = this.querySelector('[data-qty]');
        this.atc = this.querySelector('[data-atc]');
        this.buyNow = this.querySelector('[data-buy-now]');
        this.errorEl = this.querySelector('[data-error]');
        var raw = this.querySelector('[data-lpd-variants]');
        try { this.variants = raw ? JSON.parse(raw.textContent) : []; } catch (e) { this.variants = []; }
        var idInput = this.querySelector('[data-variant-id]');
        this.variant = this.variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || this.variants[0];

        this.bind();
        this.syncAvailability();
        this.applyGallery(this.variant, this.selectedValues(), true);
        this.limitQty();
        this.initWishlist();
      }

      /* ───── events ───── */
      bind() {
        var self = this;

        this.addEventListener('change', function (e) {
          if (e.target.closest('[data-option-index]')) self.onOptionChange();
        });

        this.addEventListener('click', function (e) {
          var t = e.target;
          var tile = t.closest('.lpd__tile');
          if (tile) {
            if (tile.parentElement === self.main) self.openLightbox(tile);
            else { self.setMain(tile); }
            return;
          }
          if (t.closest('[data-qty-minus]')) return self.setQty(Number(self.qty.value) - 1);
          if (t.closest('[data-qty-plus]')) return self.setQty(Number(self.qty.value) + 1);
          var acc = t.closest('.lpd__acc-btn');
          if (acc) return self.toggleAccordion(acc);
          if (t.closest('[data-wishlist]')) return self.toggleWishlist(t.closest('[data-wishlist]'));
          if (t.closest('[data-share]')) return self.share();
          var anchor = t.closest('a[href^="#"]');
          if (anchor && anchor.getAttribute('href').length > 1) {
            var target = document.querySelector(anchor.getAttribute('href'));
            if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          }
        });

        this.qty.addEventListener('change', function () { self.setQty(Number(self.qty.value)); });

        if (this.form) {
          this.form.addEventListener('click', function (e) {
            var b = e.target.closest('button[type="submit"]');
            if (b) self._lastSubmit = b;
          });
          this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
        }
      }

      /* ───── variants ───── */
      selectedValues() {
        return this.groups.map(function (g) {
          var c = g.querySelector('input:checked');
          return c ? c.value : '';
        });
      }

      findVariant(sel) {
        return this.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        })[0];
      }

      onOptionChange() {
        var sel = this.selectedValues();
        this.groups.forEach(function (g, i) {
          var label = g.querySelector('[data-selected-label]');
          if (label) label.textContent = sel[i];
        });
        var v = this.findVariant(sel);
        this.syncAvailability();
        this.variant = v || null;
        this.renderVariant(v);
        this.applyGallery(v, sel, false);
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, product: this.dataset.handle } }));
      }

      syncAvailability() {
        var self = this;
        var sel = this.selectedValues();
        this.groups.forEach(function (g, gi) {
          Array.prototype.forEach.call(g.querySelectorAll('.lpd__choice'), function (choice) {
            var val = choice.querySelector('input').value;
            var ok = self.variants.some(function (v) {
              return v.available && v.options[gi] === val && v.options.every(function (o, j) { return j === gi || o === sel[j]; });
            });
            choice.classList.toggle('is-soldout', !ok);
          });
        });
      }

      renderVariant(v) {
        var price = this.querySelector('[data-price]');
        var compare = this.querySelector('[data-compare]');
        var save = this.querySelector('[data-save]');
        var pill = this.querySelector('[data-urgency-pill]');
        var idInput = this.querySelector('[data-variant-id]');

        if (!v) {
          this.setButtons(false, this.dataset.labelSoldout);
          if (pill) pill.hidden = true;
          return;
        }

        idInput.value = v.id;
        price.textContent = this.money(v.price);
        var onSale = v.compare_at_price > v.price;
        if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? this.money(v.compare_at_price) : ''; }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off';
        }

        this.setButtons(v.available, v.available ? this.dataset.labelAdd : this.dataset.labelSoldout);

        if (pill) {
          var th = Number(this.dataset.urgencyThreshold) || 0;
          var show = this.dataset.urgency === 'true' && v.qty !== null && v.qty > 0 && v.qty <= th;
          pill.hidden = !show;
          if (show) pill.textContent = this.dataset.urgencyText.replace('{qty}', v.qty).replace('{variant}', v.title);
        }

        this.limitQty();

        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }

      setButtons(ok, label) {
        if (this.atc) { this.atc.disabled = !ok; this.atc.textContent = label; }
        if (this.buyNow) this.buyNow.disabled = !ok;
        this.clearError();
      }

      money(cents) {
        var fmt = this.dataset.moneyFormat || ('{' + '{amount}' + '}');
        function digits(n, d, t, dec) {
          d = d == null ? 2 : d; t = t || ','; dec = dec || '.';
          var s = (n / 100).toFixed(d).split('.');
          return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? dec + s[1] : '');
        }
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
          switch (key) {
            case 'amount': return digits(cents, 2);
            case 'amount_no_decimals': return digits(cents, 0);
            case 'amount_with_comma_separator': return digits(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return digits(cents, 0, '.', ',');
            case 'amount_no_decimals_with_space_separator': return digits(cents, 0, ' ');
            case 'amount_with_space_separator': return digits(cents, 2, ' ', ',');
            case 'amount_with_apostrophe_separator': return digits(cents, 2, "'", '.');
            default: return digits(cents, 2);
          }
        });
      }

      /* ───── quantity ───── */
      limitQty() {
        var v = this.variant;
        var max = v && v.qty !== null && v.policy === 'deny' && v.qty > 0 ? v.qty : '';
        if (max) this.qty.max = max; else this.qty.removeAttribute('max');
        this.setQty(Number(this.qty.value) || 1);
      }
      setQty(n) {
        var max = Number(this.qty.max) || Infinity;
        this.qty.value = Math.max(1, Math.min(isNaN(n) ? 1 : n, max));
      }

      /* ───── gallery ───── */
      visibleTiles() {
        return this.tiles.filter(function (t) { return !t.hidden; })
          .sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      }

      setMain(tile) {
        if (!tile || !this.main) return;
        var cur = this.main.querySelector('.lpd__tile');
        if (cur === tile) return;
        if (cur) this.thumbs.appendChild(cur);
        this.main.insertBefore(tile, this.main.firstChild);
        Array.prototype.slice.call(this.thumbs.children)
          .sort(function (a, b) { return a.dataset.index - b.dataset.index; })
          .forEach(function (n) { this.thumbs.appendChild(n); }, this);
      }

      applyGallery(variant, sel, initial) {
        if (!this.tiles.length) return;
        var visible = this.tiles;
        var filtered = false;

        if (this.dataset.filterAlt === 'true') {
          var vals = sel.map(function (x) { return String(x).toLowerCase().trim(); })
            .filter(function (x) { return x && x !== 'default title'; });
          if (vals.length) {
            var scored = this.tiles.map(function (t) {
              var alt = (t.dataset.alt || '').toLowerCase();
              var score = vals.filter(function (v) {
                return new RegExp('(^|[^a-z0-9])' + esc(v) + '([^a-z0-9]|$)').test(alt);
              }).length;
              return { t: t, score: score };
            });
            var max = Math.max.apply(null, scored.map(function (x) { return x.score; }));
            if (max > 0) {
              filtered = true;
              visible = scored.filter(function (x) { return x.score === max; }).map(function (x) { return x.t; });
            }
          }
        }

        var set = new Set(visible);
        this.tiles.forEach(function (t) { t.hidden = !set.has(t); });

        var ordered = this.visibleTiles();
        var byVariant = variant && variant.media
          ? ordered.filter(function (t) { return Number(t.dataset.mediaId) === variant.media; })[0]
          : null;
        var current = this.main.querySelector('.lpd__tile');
        var target = byVariant || (filtered && !initial ? ordered[0] : (current && !current.hidden ? current : ordered[0]));
        if (filtered && initial && !byVariant && current && current.hidden) target = ordered[0];
        this.setMain(target);
        if (this.main.querySelector('.lpd__tile')) this.main.querySelector('.lpd__tile').hidden = false;

        var hasThumbs = Array.prototype.some.call(this.thumbs.children, function (t) { return !t.hidden; });
        this.thumbs.hidden = !hasThumbs;
      }

      /* ───── lightbox (with swipe support on mobile) ───── */
      openLightbox(tile) {
        var self = this;
        this.lbList = this.visibleTiles();
        this.lbIndex = Math.max(0, this.lbList.indexOf(tile));
        this.lbReturn = document.activeElement;

        if (!this.lb) {
          var lb = document.createElement('div');
          lb.className = 'lpd-lb';
          lb.setAttribute('role', 'dialog');
          lb.setAttribute('aria-modal', 'true');
          lb.setAttribute('aria-label', 'Product image');
          lb.hidden = true;
          lb.innerHTML = '<img alt=""><button type="button" class="lpd-lb__close" aria-label="Close">&times;</button>' +
            '<button type="button" class="lpd-lb__prev" aria-label="Previous image">&lsaquo;</button>' +
            '<button type="button" class="lpd-lb__next" aria-label="Next image">&rsaquo;</button>';
          document.body.appendChild(lb);
          this.lb = lb;
          lb.addEventListener('click', function (e) {
            if (e.target.classList.contains('lpd-lb__close') || e.target === lb) self.closeLightbox();
            else if (e.target.classList.contains('lpd-lb__prev')) self.stepLightbox(-1);
            else if (e.target.classList.contains('lpd-lb__next')) self.stepLightbox(1);
          });
          var startX = null;
          lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
          lb.addEventListener('touchend', function (e) {
            if (startX === null) return;
            var dx = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) > 50) self.stepLightbox(dx < 0 ? 1 : -1);
          }, { passive: true });
          this._lbKey = function (e) {
            if (lb.hidden) return;
            if (e.key === 'Escape') self.closeLightbox();
            if (e.key === 'ArrowLeft') self.stepLightbox(-1);
            if (e.key === 'ArrowRight') self.stepLightbox(1);
          };
          document.addEventListener('keydown', this._lbKey);
        }
        this.showLightbox();
        this.lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        this.lb.querySelector('.lpd-lb__close').focus();
      }
      showLightbox() {
        var t = this.lbList[this.lbIndex];
        var img = this.lb.querySelector('img');
        img.src = t.dataset.full;
        img.alt = t.querySelector('img').alt;
        var multi = this.lbList.length > 1;
        this.lb.querySelector('.lpd-lb__prev').hidden = !multi;
        this.lb.querySelector('.lpd-lb__next').hidden = !multi;
      }
      stepLightbox(d) {
        var n = this.lbList.length;
        this.lbIndex = (this.lbIndex + d + n) % n;
        this.showLightbox();
      }
      closeLightbox() {
        this.lb.hidden = true;
        document.documentElement.style.overflow = '';
        if (this.lbReturn && this.lbReturn.focus) this.lbReturn.focus();
      }
      disconnectedCallback() {
        if (this.lb) this.lb.remove();
        if (this._lbKey) document.removeEventListener('keydown', this._lbKey);
        document.documentElement.style.overflow = '';
      }

      /* ───── accordion (one open at a time) ───── */
      toggleAccordion(btn) {
        var open = btn.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(this.querySelectorAll('.lpd__acc-btn'), function (b) {
          b.setAttribute('aria-expanded', 'false');
          document.getElementById(b.getAttribute('aria-controls')).classList.remove('is-open');
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          document.getElementById(btn.getAttribute('aria-controls')).classList.add('is-open');
        }
      }

      /* ───── wishlist + share ───── */
      wishlist() {
        try { return JSON.parse(localStorage.getItem('lpd_wishlist') || '[]'); } catch (e) { return []; }
      }
      initWishlist() {
        var btn = this.querySelector('[data-wishlist]');
        if (btn) btn.setAttribute('aria-pressed', this.wishlist().indexOf(this.dataset.handle) > -1 ? 'true' : 'false');
      }
      toggleWishlist(btn) {
        var list = this.wishlist();
        var h = this.dataset.handle;
        var i = list.indexOf(h);
        if (i > -1) list.splice(i, 1); else list.push(h);
        try { localStorage.setItem('lpd_wishlist', JSON.stringify(list)); } catch (e) {}
        btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
        document.dispatchEvent(new CustomEvent('wishlist:toggle', { detail: { handle: h, added: i === -1 } }));
        this.toast(i > -1 ? 'Removed from wishlist' : 'Saved to wishlist');
      }
      share() {
        var self = this;
        var data = { title: document.title, url: window.location.href };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(data.url).then(function () { self.toast('Link copied'); }, function () {});
        }
      }
      toast(msg) {
        var el = this.querySelector('[data-toast]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = false;
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(function () { el.hidden = true; }, 2000);
      }

      /* ───── cart ───── */
      clearError() { if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; } }
      showError(msg) { if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.hidden = false; } }

      onSubmit(e) {
        var self = this;
        var submitter = e.submitter || this._lastSubmit;
        if (!this.variant || !this.variant.available) { e.preventDefault(); return; }
        if (submitter && submitter.hasAttribute('data-buy-now')) return;      // native post, then /checkout
        if (this.dataset.cartBehavior === 'redirect') return;                 // native post, then /cart

        e.preventDefault();
        this.clearError();
        var btn = this.atc;
        var label = this.dataset.labelAdd;
        btn.disabled = true;

        fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
            btn.textContent = self.dataset.labelAdded;
            return fetch(self.dataset.cartJsUrl, { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                self.updateCartCount(cart);
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, item: res.data } }));
              });
          })
          .catch(function (err) { self.showError(err.message); })
          .then(function () {
            setTimeout(function () {
              btn.disabled = !(self.variant && self.variant.available);
              btn.textContent = self.variant && self.variant.available ? label : self.dataset.labelSoldout;
            }, 1600);
          });
      }

      updateCartCount(cart) {
        var sel = ['.cart-count-bubble span[aria-hidden="true"]', '.cart-count-bubble', '[data-cart-count]', '.cart-count'];
        sel.forEach(function (s) {
          Array.prototype.forEach.call(document.querySelectorAll(s), function (n) {
            if (n.children.length && s === '.cart-count-bubble') return;
            n.textContent = cart.item_count;
            n.classList.remove('hidden');
            n.removeAttribute('hidden');
          });
        });
      }
    }

    customElements.define('lux-product', LuxProduct);
  })();
  } catch(e) { console.error(e); }
})();

})();
